<template>

	<div class="admin-dashboard-plugins-EmployeeOnlineGrid">

		<dashboard-plugin
			name="Gebruikers online"
			instruction="Bekijk sinds wanneer en hoe lang gebruikers en touchscreens online zijn."
			headerPaddingRight="25%"
			:loading="loading"
			:loadedFirstTime="loadedFirstTime"
			:hasData="hasData"
		>

			<grid
				ref="grid"
				style="margin-top: -72px"
				:columns="gridColumns"
				:rows="gridRows"
			/>

		</dashboard-plugin>

	</div>

</template>

<script>

import DashboardPlugin from "./common/DashboardPlugin";
import Api from "../api";
import Grid from "./common/Grid";
import loader from "./mixins/loader";

export default {
	mixins: [loader],
	components: {
		DashboardPlugin,
		Grid

	},
	props: {

	},

	data: () => {
		return {

			// The columns that are set on the table/ grid with the employee scores
			gridColumns: [
				{
					property: 'care_group',
					title: 'Zorggroep',
					direction: null,
					filterable: true,
				},
				{
					property: 'account_name',
					title: 'Naam',
					direction: null,
					filterable: true,
				},
				{
					property: 'created_at_formatted',
					title: 'Startmoment',
					direction: null,
					filterable: false,
				},
				{
					property: 'updated_at_formatted',
					title: 'Eindmoment',
					direction: null,
					filterable: false,
				},
				{
					property: 'total_minutes',
					title: 'Duur online',
					direction: null,
					filterable: false,
				},
			],

			// The values for the above columns
			gridRows: [],

			// Used to know if the grid is already patched to not handle a 'enter' press as a page reload
			formsIsPatched: false,
		}
	},

	methods: {
		updateHandler()
		{
			if(!this.formsIsPatched)
			{
				let forms = document.querySelectorAll("form.vue-ads-font-sans.vue-ads-flex-grow");

				if(forms.length > 0)
					this.patchForm(forms[0])
			}

			this.update();
		},

		async update()
		{
			this.incrementLoading()

			// Needed to set our
			let table = this?.$refs?.grid?.$refs?.table.$refs.table

			// Get the employees with their corresponding score. These are used to display in the grid
			this.gridRows = await Api.getEmployeesOnline()

			if(table) {
				this.$nextTick(() => {
					table.totalFilteredRowsChanged(table.filteredRows.length)
				})
			}

			this.decrementLoading()
		},

		// Don't reload the page when we press enter after typing something in the filter
		patchForm(formToPatch)
		{
			formToPatch.addEventListener('submit', (event) => {
				event.preventDefault()
				return false
			})
		}

	},

	computed: {

		hasData()
		{
			return this.gridRows.length > 0;
		}
	}
}
</script>

<style lang="scss">

	.admin-dashboard-plugins-EmployeeOnlineGrid .admin-dashboard-plugins-common-Grid th:not(:first-child) {
		width: 175px;
	}

</style>
